var _g, _circle, _circle2, _circle3, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 496,
    height: 496,
    viewBox: "0 0 496 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1675_59152)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 248,
    r: 219,
    fill: "url(#paint0_radial_1675_59152)",
    fillOpacity: 0.7
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 248.001,
    r: 194.766,
    fill: "url(#paint1_radial_1675_59152)",
    fillOpacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 248.001,
    r: 175.02,
    fill: "url(#paint2_radial_1675_59152)",
    fillOpacity: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 247.999,
    r: 153.48,
    fill: "url(#paint3_radial_1675_59152)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1675_59152)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248 379.041C320.372 379.041 379.041 320.372 379.041 248C379.041 175.628 320.372 116.959 248 116.959C175.628 116.959 116.959 175.628 116.959 248C116.959 320.372 175.628 379.041 248 379.041ZM247.992 130.077C249.842 130.077 251.681 130.119 253.51 130.204C192.309 156.536 146.2 212.697 134.959 281.779C131.769 271.082 130.055 259.748 130.055 248.014C130.055 182.879 182.857 130.077 247.992 130.077ZM361.259 215.046C358.531 205.659 354.669 196.755 349.829 188.492C347.359 188.153 344.864 187.885 342.346 187.688C272.504 182.233 211.464 234.43 206.009 304.272C204.442 324.332 207.631 343.666 214.629 361.165C223.737 363.847 233.303 365.458 243.182 365.854C233.042 348.385 227.917 327.766 229.608 306.105C234.045 249.299 283.692 206.844 340.499 211.281C347.67 211.841 354.611 213.121 361.259 215.046ZM324.408 158.179C247.159 162.074 182.966 222.824 176.784 301.989C175.666 316.297 176.514 330.306 179.1 343.749C171.478 338.254 164.538 331.871 158.432 324.752C157.958 316.805 158.023 308.731 158.66 300.57C164.953 219.996 225.074 156.509 300.995 142.629C309.429 146.88 317.284 152.113 324.408 158.179ZM365.928 247.834C357.539 243.596 348.199 240.89 338.247 240.113C297.364 236.92 261.634 267.474 258.441 308.357C256.838 328.878 263.737 348.1 276.177 362.561C284.56 360.506 292.591 357.554 300.162 353.813C287.608 343.569 280.114 327.542 281.471 310.164C283.671 281.999 308.287 260.95 336.452 263.149C346.533 263.937 355.702 267.596 363.22 273.261C364.994 265.127 365.929 256.679 365.929 248.014L365.928 247.834ZM334.906 282.952C343.689 283.638 351.341 287.887 356.554 294.171C348.385 313.36 335.277 329.941 318.827 342.317C307.577 336.865 300.241 324.927 301.273 311.711C302.619 294.482 317.677 281.606 334.906 282.952Z",
    fill: "url(#paint4_radial_1675_59152)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1675_59152",
    x: 0.278688,
    y: 0.278688,
    width: 495.443,
    height: 495.443,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.3607,
    result: "effect1_foregroundBlur_1675_59152"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1675_59152",
    x: 116.959,
    y: 116.959,
    width: 262.082,
    height: 262.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.24385
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1675_59152"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1675_59152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248 248) rotate(90) scale(219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1675_59152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248 248.001) rotate(90) scale(194.766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1675_59152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248 248.001) rotate(90) scale(175.02)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1675_59152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248 247.999) rotate(90) scale(153.48)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1675_59152",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248 116.959) rotate(90) scale(262.082)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.522606,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736618,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2C2C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.b4a8e5e3b967bc8a2b8b9fd213716210.svg";
export { ForwardRef as ReactComponent };